export const KPI_Card_Header_Label = {
  sku: 'Total SKUs with Models',
  model: 'Total Models',
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
}

export const Should_Cost_Workbench_Title = {
  Page_Header: 'SKU Should Cost Mapping',
  Search: 'Search',
  Sku_List: 'SKU List',
  Attach_Models: 'Attach Models',
  Selected_Sku: 'Selected SKU',
  Attach_Btn_Label: 'Attach (0) Model to SKU',
  Cancel: 'Cancel',
  View_Page_Title: 'View & Manage Should Cost',
  Delete_Should_Cost_Heading: 'Delete SKU-Model Mapping',
  Edit_Should_Cost_Heading: 'Edit Model',
  Confirm_Delete_Should_Cost: 'Please confirm if you want to delete...!',
  Po_Vs_Should_Cost_Chart_Heading: 'Cost Trend',
  Breakdown_Chart_Heading: 'Breakdown Details',
  No_SKU_Found: "No SKU's Found",
  //upload sku, po, vendor
  Upload_Sku: 'SKU Master Upload',
  Upload_Po: 'PO Upload',
  Upload_Vendor: 'Vendor Master Upload',
  Preview_Sku: 'SKU Master Preview',
  Preview_Po: 'PO Preview',
  Preview_Vendor: 'Vendor Master Preview',
  Download_Sku_Template: 'SKU Master Template',
  Download_Po_Template: 'PO Template',
  Download_Vendor_Template: 'Vendor Master Template',
  Sku_Template_File_Name: 'sku_master_template',
  Po_Template_File_Name: 'po_template',
  Vendor_Template_File_Name: 'vendor_master_template',
  Sku_Error_File_Name: 'sku_master_error_file',
  Po_Error_File_Name: 'po_template_error_file',
  Vendor_Error_File_Name: 'vendor_master_error_file',
  Upload_Type: {
    Sku: 'sku',
    Po: 'po',
    Vendor: 'vendor',
  },
  File_Size: 20,
}

export const Should_Cost_Workbench_Messages = {
  Get_Models_Count_Error: 'Failed to get should cost models count!',
  Get_Models_Data_Error: 'Failed to get should cost models data!',
  BOTTOM_UP_PERCENTAGE_DISABLE_MSG: '% option will be disabled for bottom up models',
  Confirm_Delete_Should_Cost:
    "This will delete the SKU-Model mapping. Please click 'Confirm' to proceed or 'Cancel' to abort.",
  Confirm_Edit_Should_Cost:
    'You are about to edit this model. Choose how you want the changes to apply:',
  Edit_Only_One_SKU_Label: 'Changes will apply only to the SKU you are viewing.',
  Edit_All_SKU_Label: 'Changes will apply to all the SKUs attatched to this model.',
  Get_Sku_Kpi_Error: 'Failed to get SKU KPIs!',
  Get_Sku_List_Error: 'Failed to get SKU list!',

  //upload sku, po, vendor
  Column_Missmatch:
    'File validations failed due to column mismatch. (Please download template for reference)',
  Empty_Rows_File:
    'File validation failed as empty rows detected. (Please upload file with non-empty records)',
  File_Size: `  File is larger than  ${Should_Cost_Workbench_Title?.File_Size}MB. (Please select a file with a size less than  ${Should_Cost_Workbench_Title?.File_Size}MB)`,
  File_Passward_Protected: 'File is password protected. (Please select an unprotected file)',
  Download_Fail: 'File download failed',
  Upload_Successful: 'Data uploaded successfully',
  Preview_Heading:
    'File Validation Successful. This is a preview of initial 5 records from the selected files.',
  Sku_Upload_Successful: "SKU's uploaded successfully",
  Po_Upload_Successful: 'PO uploaded successfully',
  Vendor_Upload_Successful: 'Vendors uploaded successfully',
  Sku_Upload_Fail: 'SKU upload failed',
  Po_Upload_Fail: 'PO upload failed',
  Vendor_Upload_Fail: "Vendor's upload failed",
  Attach_File_Error_Message: 'Failed to attach model to selected sku!',
  No_Models_Found: "No Models Found. Click on 'Attach Models' button to add models to this SKU.",
}

export const Should_Cost_Workbench_Labels = {
  Delete_Tooltip_Label: 'Delete SKU-Model Mapping',
  Edit_Tooltip_Label: 'Update SKU-Model Mapping',
  Edit_Tooltip_Label_BottomUp: 'Can not edit Bottom Up model',
}

export const Currency_Data = [
  {
    label: '%',
    value: 'Percentage',
  },
  {
    label: 'USD : $',
    value: 'USD',
  },
  {
    label: 'EUR : €',
    value: 'EUR',
  },
  {
    label: 'GBP : £',
    value: 'GBP',
  },
  // {
  //   label: 'INR : ₹',
  //   value: 'INR',
  // },
]

export const Creation_Approach = {
  top_down: 'Top Down',
  bottom_up: 'Bottom Up',
}
